<template>
  <div class="picker" role="radiogroup" :aria-label="ariaLabel" :style="{ '--cols': columns }">
    <button
      v-for="n in options"
      :key="n"
      type="button"
      class="chip"
      :class="{ selected: n === modelValue, blocked: n === blockedValue }"
      role="radio"
      :aria-checked="n === modelValue"
      :disabled="n === blockedValue"
      :title="n === blockedValue ? blockedHint : null"
      @click="$emit('update:modelValue', n)"
    >{{ n }}</button>
  </div>
</template>

<script>
export default {
  name: 'BbNumberPicker',
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: Number, default: null },
    max: { type: Number, required: true },
    blockedValue: { type: Number, default: null },
    blockedHint: { type: String, default: '' },
    ariaLabel: { type: String, default: 'Aantal slagen' }
  },
  computed: {
    options() {
      return Array.from({ length: this.max + 1 }, (_, i) => i)
    },
    /**
     * Gewenst aantal kolommen op tablet: minstens 6, en bij veel slagen de helft,
     * zodat 0–10 netjes over twee rijen valt in plaats van een verloren 10 op een
     * derde rij.
     */
    columns() {
      return Math.max(6, Math.ceil(this.options.length / 2))
    }
  }
}
</script>

<style scoped>
.picker {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.chip {
  min-width: 2.75rem;
  min-height: 2.75rem;
  padding: 0 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  font-family: inherit;
  color: #2c3e50;
  background: #fff;
  border: 2px solid #aac8aa;
  border-radius: 8px;
  cursor: pointer;
  touch-action: manipulation;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.chip.selected {
  background: #2c3e50;
  border-color: #2c3e50;
  color: #fff;
}

.chip.blocked {
  background: #f4f4f4;
  border-color: #e0e0e0;
  color: #bbb;
  cursor: not-allowed;
  text-decoration: line-through;
}

.chip:active:not(:disabled) { opacity: 0.75; }

@media (hover: hover) {
  .chip:hover:not(:disabled):not(.selected) { border-color: #7a9a7a; }
}

/* Op tablet verdelen de knoppen zich gelijkmatig over de breedte van het vak.
   Elke kolom is minstens 1/--cols van de breedte, zodat de rijen evenwichtig
   gevuld worden; is het vak daarvoor te smal, dan wint de minimale tikbreedte
   en lopen de knoppen door op een extra rij. */
@media (min-width: 600px) {
  .picker {
    display: grid;
    grid-template-columns: repeat(
      auto-fill,
      minmax(max(2.4rem, calc((100% - (var(--cols) - 1) * 0.5rem) / var(--cols))), 1fr)
    );
    gap: 0.5rem;
  }

  .chip {
    min-width: 0;
    min-height: 3rem;
    font-size: 1.1rem;
  }
}
</style>
